import { render, staticRenderFns } from "./layout-product-question.vue?vue&type=template&id=5f8e67e0&scoped=true"
import script from "./layout-product-question.vue?vue&type=script&lang=js"
export * from "./layout-product-question.vue?vue&type=script&lang=js"
import style0 from "./layout-product-question.vue?vue&type=style&index=0&id=5f8e67e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8e67e0",
  null
  
)

export default component.exports